import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Container, Row, Col, Card } from "react-bootstrap";
import {
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaInstagram,
} from "react-icons/fa";

import teamimg from "../assets/img/team/Parab Sir 2PHOTO-2025-11-05-16-18-07.jpg";

const lawyers = [
  {
    name: "Adv. Niranjan Jagtap",
    title: "Senior Partner",
    img: teamimg,
  },
  {
    name: "Adv. Shreeprasad Parab",
    title: "Senior Partner",
    img: teamimg,
  },
];

const Ourteamabout = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <section className="py-5 bg-light" data-aos="fade-up">
      <div className="container-fluid px-4">
        {/* Title */}
        {/* <div className="text-center mb-5">
          <h2 className="section-title">Our Lawyers</h2>
          <p className="text-muted">
            Meet our team of dedicated legal professionals.
          </p>
        </div> */}

        {/* ⭐ Special Card */}
        <Row className=" bg-white rounded shadow-lg p-4">
          {/* LEFT */}
          <Col md={3} className="text-center mb-4 mb-md-0">
            <Card className="lawyer-card border-0 shadow-sm">
              <div className="card-img-wrapper">
                <Card.Img
                  variant="top"
                  src={lawyers[1].img}
                  className="lawyer-img"
                />

                <div className="overlay">
                  {/* <div className="social-icons">
                    <a href="#">
                      <FaFacebookF />
                    </a>
                    <a href="#">
                      <FaTwitter />
                    </a>
                    <a href="#">
                      <FaLinkedinIn />
                    </a>
                    <a href="#">
                      <FaInstagram />
                    </a>
                  </div> */}
                </div>
              </div>

              <Card.Body>
                <Card.Title>{lawyers[1].name}</Card.Title>
                <Card.Text className="text-muted">{lawyers[1].title}</Card.Text>
              </Card.Body>
            </Card>
          </Col>

          {/* RIGHT */}
          <Col md={9}>
            <p className="text-muted" style={{ textAlign: "justify" }}>
              Adv. Shri. Shreeprasad Parab is a trained Civil Engineer from
              Mumbai University and worked in the capacity of a Vastu Visharadh,
              License Surveyor in the field of Architect as well as a Structural
              and Chartered Engineer.
              <br />
              <br />
              Despite a commendable success in business of Real Estate, he felt
              that it’s necessary to have a Law education in order to serve the
              society in an efficient manner. Therefore, he completed his LLB
              and LL.M. from Mumbai University and is practising as an Advocate
              in the Supreme Court and the Bombay High Court. He also has best
              skills of Arbitration and Conciliation and is stalwart in RERA and
              Cooperative Sector. He is appointed as an Arbitrator by the
              Commissioner of Co-operation for Multi-State Co-operative Sector.
              He is also appointed as an Expert Director on the Maharashtra
              State Co-operative Housing Society Federation Ltd
              <br />
              <br />
              He is one of the author in the “Housing Cooperatives” Book which
              is launched by NCUI (National Co-operative Union of India) headed
              by Hon’ble Union Minister Shri Amit Shahji and inaugurated by
              Hon’ble Union Minister Shri Purshottam Rupalji in November 2023.
              <br />
              <br />
              He has also written a book on Election of Housing Societies titled
              “Election CHS Training” and created App named “Housing Co-op
              Master” and “Election CHS Training”.
              <br />
              <br />
              His Articles and quotes are published frequently in various
              newspaper such as Times of India, Mid-Day, Maharashtra Times and
              other newspapers. He provides educational lectures on various
              topics on “VIDELICET LAW” Youtube Channel. He actively
              participates in National as well as International conference. He
              has expertise in imparting Legal knowledge in simplified style and
              he conducts online / offline lecture series on Constitution of
              India, Transfer of Property, Indian Contracts, Evidence,
              Cooperative laws etc. He was also invited on Sahyadri Doordarshan
              Channel for discussion on Apartment and Co-operative Laws which
              was telecast on the Doordarshan Channel on 5th , 6th and 7th
              August 2024.
            </p>
          </Col>
        </Row>
      </div>
      
    </section>
  );
};

export default Ourteamabout;
